// src/routes/RespiratoryRateTool.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import RecordingRRRouter from "./RecordingRRRouter";

/**
 * Guarded wrapper for the RR recording pod.
 * If consent is missing, redirect to /consent as a normal page.
 */
export default function RespiratoryRateTool(props) {
  const location = useLocation();
  const accepted =
    typeof window !== "undefined" &&
    window.localStorage.getItem("rr-consent-accepted") === "true";

  if (!accepted) {
    return (
      <Navigate
        to="/consent"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  return <RecordingRRRouter {...props} />;
}
